import moment from "moment";

import { Label } from "semantic-ui-react";

import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import Flex from "../../../../../components/Flex/Flex";

import StudioDropdownMenu from "../../../components/StudioDropdownMenu/StudioDropdownMenu";
import { onlineAccessor } from "../../../utils/studioAccessors";

export default function useStudiosTableColumns() {
	const { t } = useTranslation();

	return useMemo(
		() => [
			{
				id: "name",
				Header: t("name"),
				Cell: ({ row, value }) => (
					<Flex style={{ gap: 10, justifyContent: "flex-start" }}>
						<Label circular empty style={{ background: row.color }} />
						<div>{value}</div>
					</Flex>
				),
			},
			{
				id: "groups",
				Header: t("studioGroupTags"),
				accessor: ({ groupTags }) => groupTags?.join(", "),
			},
			{
				id: "status",
				Header: t("status"),
				accessor: ({ active }) => (active ? t("active") : t("inactive")),
			},
			{
				id: "online",
				Header: t("activity", "Activity"),
				accessor: (studio) => (onlineAccessor(studio) ? t("online") : t("offline")),
				Cell: ({ row, value }) => {
					return (
						<Flex style={{ gap: 10, justifyContent: "flex-start" }}>
							<Label circular empty color={onlineAccessor(row) ? "green" : "red"} />
							<div>
								{value} {row.online && `(${moment(row.online?.toDate()).fromNow()})`}
							</div>
						</Flex>
					);
				},
			},
			{
				id: "version",
				Header: t("version", "Version"),
			},
			{
				id: "menu",
				textAlign: "right",
				collapsing: true,
				disableSortBy: true,
				Cell: ({ row }) => <StudioDropdownMenu studio={row} />,
			},
		],
		[t],
	);
}
